import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import TextColorPalette from './TextColorPalette';
/**
 * The text colour button's swatches on a phone, where a menu from the
 * composer's toolbar wouldn't show (Mobile Safari, the toolbar scrolling
 * sideways) - fof/rich-text's own "+" and link buttons open a modal there
 * too.
 */
export default class TextColorModal extends Modal {
  className() {
    return 'TextColorModal Modal--small';
  }
  title() {
    return app.translator.trans('champis-forum.forum.text_color.button');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m(TextColorPalette, {
      current: this.attrs.current,
      withDefault: this.attrs.withDefault,
      onpick: color => {
        this.hide();
        this.attrs.onpick(color);
      }
    }));
  }
}
flarum.reg.add('champis-forum', 'forum/components/TextColorModal', TextColorModal);